// ヘルパー関数プラグイン化

import { dateFormat, dateYmd, dateYmdw, dateYm, dateMd, dateMdw, dateNj, dateYmdHi, dateYmdForInputDate, today, now } from './date-format';
import { numberFormat, clock } from './text-format';
import { isBlank } from './typing';

export default {
    install: (app) => {
        app.config.globalProperties.$helper = {
            date: dateFormat,
            ymd: dateYmd,
            ymdw: dateYmdw,
            ym: dateYm,
            md: dateMd,
            mdw: dateMdw,
            nj: dateNj,
            ymdForInputDate: dateYmdForInputDate,
            ymdhi: dateYmdHi,
            today: today,
            now: now,
            number: numberFormat,
            clock: clock,
            isBlank: isBlank,
        }
    }
}
